import FieldMappingTable from './FieldMappingTable';
export default FieldMappingTable;
